import { QueryClient } from '@tanstack/react-query';

type DefaultMeta = {
  preview: boolean;
};

// Allows to easily create a query client with the right options
export const createQueryClient = (
  defaultMeta: DefaultMeta = { preview: false },
) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // Set cacheTime to 24h for persisted Cache
        gcTime: 1000 * 60 * 60 * 24,
        refetchOnWindowFocus: false,
        retry: 2,
        meta: {
          // By default we don't want to dehydrate queries
          dehydrate: false,
          // Pass down default meta data
          ...defaultMeta,
        },
      },
    },
  });
